import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { StageService } from './stage.service';

@Injectable()
export class SceneLoadingService {
  private _isSceneLoaded = new BehaviorSubject<boolean>(false);
  public readonly isSceneLoaded$ = this._isSceneLoaded.asObservable();

  constructor(private stageService: StageService) {
    // Подписываемся на добавление объектов в сцену
    this.stageService.objectAdded.subscribe(() => {
      this.checkSceneLoaded();
    });

    // Подписываемся на удаление объектов из сцены
    this.stageService.objectRemoved.subscribe(() => {
      this.checkSceneLoaded();
    });
  }

  private checkSceneLoaded(): void {
    const scene = this.stageService.getScene();
    if (!scene) {
      console.log('SceneLoadingService: Scene is null');
      this._isSceneLoaded.next(false);
      return;
    }

    // Проверяем наличие основных 3D объектов в сцене
    const hasCompoundFloor = scene.getObjectByName('compoundFloor');
    const hasRailing = scene.getObjectByName('railing');
    const hasStairs = scene.getObjectByName('stairs');
    const hasEnvironment = scene.getObjectByName('environment');
    
    // Сцена считается загруженной, если есть пол И (перила ИЛИ ступеньки ИЛИ окружение)
    const hasFloor = !!hasCompoundFloor;
    const hasContent = !!(hasRailing || hasStairs || hasEnvironment);
    const isLoaded = hasFloor && hasContent;
    
    // console.log('SceneLoadingService: Checking scene loaded state:', {
    //   hasCompoundFloor: !!hasCompoundFloor,
    //   hasRailing: !!hasRailing,
    //   hasStairs: !!hasStairs,
    //   hasEnvironment: !!hasEnvironment,
    //   hasFloor,
    //   hasContent,
    //   isLoaded,
    //   sceneChildren: scene.children.length
    // });
    
    this._isSceneLoaded.next(isLoaded);
    
    // Обновляем тестовый UI если он существует
    if (typeof window !== 'undefined' && (window as any).updateSceneStatus) {
      (window as any).updateSceneStatus(isLoaded);
    }
  }

  public getIsSceneLoaded(): boolean {
    return this._isSceneLoaded.value;
  }

  public setSceneLoaded(loaded: boolean): void {
    this._isSceneLoaded.next(loaded);
  }

  public forceCheck(): void {
    this.checkSceneLoaded();
  }
} 


// WEBPACK FOOTER //
// ./src/app/services/scene-loading.service.ts